import cx from 'clsx';
import * as React from 'react';
import { getAddonIconStyle } from './get-addon-icon-style';
import styles from './shared-addons-section.module.css';

interface SharedAddon {
  description: string;
  iconLightPath: string;
  iconDarkPath: string;
}

interface SharedAddonsSectionProps {
  title: string;
  addons: SharedAddon[];
}

export function SharedAddonsSection({ title, addons }: SharedAddonsSectionProps): React.ReactNode {
  return (
    <div className={styles.container}>
      <h3 className={cx('heading-subsection', styles.title)}>{title}</h3>
      <ul className={styles.list}>
        {addons.map(({ description, iconLightPath, iconDarkPath }) => (
          <li className={styles['list-item']} key={description}>
            <div
              aria-hidden="true"
              className={cx('mr-8', styles.image)}
              style={getAddonIconStyle(iconLightPath, iconDarkPath)}
            />
            <span className="body-standard">{description}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
